import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { CircularProgress, Box } from "@material-ui/core";
import QuizForm from "../../components/QuizForm";
import api from "../../services/api";
import { captureUTMParams, storeUTMParams } from "../../utils/utmCapture";

const PublicQuizPage = () => {
    const { slug } = useParams();
    const [loading, setLoading] = useState(true);
    const [landingPage, setLandingPage] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Capturar parâmetros UTM da URL
        const utmParams = captureUTMParams();
        storeUTMParams(utmParams);

    const fetchLandingPage = async () => {
        try {
            const { data } = await api.get(`/lp/${slug}`);
            
            // Garantir que campos JSON sejam parseados corretamente
            const safeParse = (data) => {
                if (typeof data === 'string') {
                    try {
                        return JSON.parse(data);
                    } catch (e) {
                        return [];
                    }
                }
                return Array.isArray(data) ? data : [];
            };

            const parsedData = {
                ...data,
                quizQuestions: safeParse(data.quizQuestions)
            };

            setLandingPage(parsedData);
        } catch (err) {
            setError("Landing page não encontrada");
        } finally {
            setLoading(false);
        }
    };

        fetchLandingPage();
    }, [slug]);

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress />
            </Box>
        );
    }

    if (error || !landingPage || !landingPage.quizQuestions || landingPage.quizQuestions.length === 0) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <div>Quiz não encontrado</div>
            </Box>
        );
    }

    return (
        <QuizForm
            slug={slug}
            landingPageId={landingPage.id}
            questions={landingPage.quizQuestions}
            primaryColor={landingPage.primaryColor || "#6366f1"}
            logo={landingPage.headerLogo}
            footerText={landingPage.footerCopyright}
        />
    );
};

export default PublicQuizPage;
